import { type FC } from "react";
import Box from "@mui/material/Box";
import { useGetUsersFromCurrentOrganisation } from "../../../api/users";
import type { InputProps } from "../../DynamicInput";
import { PersonIcon3 } from "../../../shared/icons";
import { SingleAutocomplete } from "../../shared/SingleAutocomplete";
import { MultiAutocomplete } from "../../shared/MultiAutocomplete";
import { inlineInputStateStyles } from "./InlineInputState";

export const PersonSingleAutocomplete: FC<InputProps<string>> = props => {
  return <Person {...props} variant="singleSelect" />;
};
export const PersonMultipleAutocomplete: FC<InputProps<string[]>> = props => {
  return <Person {...props} variant="multiSelect" />;
};

export type SingleProps = InputProps<string> & { variant: "singleSelect" };
export type MultiProps = InputProps<string[]> & { variant: "multiSelect" };

const Person: FC<SingleProps | MultiProps> = props => {
  const { data } = useGetUsersFromCurrentOrganisation();

  if (!data) return <Box sx={{ height: 36, pl: 2, width: "100%" }} />;

  const options = data.users.map(user => ({
    label: `${user.firstName} ${user.lastName}`,
    value: user.userId,
    description: user.email,
  }));

  return props.variant === "singleSelect" ? (
    <SingleAutocomplete
      {...props}
      options={options}
      denseOptions
      inlineInputStateStyles={inlineInputStateStyles}
      renderIcon={iconProps => <PersonIcon3 {...iconProps} />}
      noOptionsTextKey="DynamicForm.PersonSelect.Empty"
      placeholderKey="DynamicForm.Inline.InputPlaceholder"
      chipVariant="entity"
    />
  ) : (
    <MultiAutocomplete
      {...props}
      options={options}
      denseOptions
      inlineInputStateStyles={inlineInputStateStyles}
      renderIcon={iconProps => <PersonIcon3 {...iconProps} />}
      noOptionsTextKey="DynamicForm.PersonSelect.Empty"
      placeholderKey="DynamicForm.Inline.InputPlaceholder"
      chipVariant="entity"
    />
  );
};
